import { Box, styled } from "@mui/material";

const FullHeightBox = styled(Box)(() => ({
  minHeight: "100vh",
}));

export { FullHeightBox };
